/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Location_Share_HelpInputs */

const en_ticket_location_share_help = /** @type {(inputs: Ticket_Location_Share_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When off, the customer can't see your position — independent of ServiceNow updates.`)
};

const ja_ticket_location_share_help = /** @type {(inputs: Ticket_Location_Share_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフのとき、お客様には現在地が表示されません — ServiceNowのステータス更新には影響しません。`)
};

const fr_ticket_location_share_help = /** @type {(inputs: Ticket_Location_Share_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand désactivé, le client ne voit pas votre position — indépendamment des mises à jour ServiceNow.`)
};

const de_ticket_location_share_help = /** @type {(inputs: Ticket_Location_Share_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn ausgeschaltet, sieht der Kunde Ihre Position nicht — unabhängig von ServiceNow-Statusmeldungen.`)
};

/**
* | output |
* | --- |
* | "When off, the customer can't see your position — independent of ServiceNow updates." |
*
* @param {Ticket_Location_Share_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_location_share_help = /** @type {((inputs?: Ticket_Location_Share_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Location_Share_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_location_share_help(inputs)
	if (locale === "ja") return ja_ticket_location_share_help(inputs)
	if (locale === "fr") return fr_ticket_location_share_help(inputs)
	return de_ticket_location_share_help(inputs)
});